import { convert } from '../utils'

let lines = [


  {text:['优胜美地国家公园'],startTime:'00:00:01.00', endTime:'00:00:02.17'},
  {text:['以其宏伟的瀑布'],startTime:'00:00:02.18', endTime:'00:00:03.24'},
  {text:['和花岗岩地表而闻名'],startTime:'00:00:04.00', endTime:'00:00:06.14'},
  {text:['于1984年'],startTime:'00:00:06.15', endTime:'00:00:07.23'},
  {text:['被纳入联合国教科文组织'],startTime:'00:00:07.24', endTime:'00:00:10.04'},
  {text:['世界遗产'],startTime:'00:00:10.05', endTime:'00:00:11.05'},
  {text:['公园内'],startTime:'00:00:11.19', endTime:'00:00:12.16'},
  {text:['有四面绝壁的优胜美地山谷'],startTime:'00:00:12.17', endTime:'00:00:15.15'},
  {text:['也有高山美景的'],startTime:'00:00:15.16', endTime:'00:00:17.11'},
  {text:['图奥勒米牧场'],startTime:'00:00:17.12', endTime:'00:00:19.07'},
  {text:['自然风光让人叹为观止'],startTime:'00:00:19.08', endTime:'00:00:22.06'},
  {text:['这里还是是攀岩爱好者的圣地'],startTime:'00:00:22.07', endTime:'00:00:25.08'},
  {text:['来到这里一定要和半圆顶合个影'],startTime:'00:00:25.09', endTime:'00:00:28.11'},


]

export default convert(lines)
